import "core-js/modules/es6.array.for-each.js";
import { useCallbackRef } from './useRef';
import { assignRef } from './assignRef';
export function useMergeRefs(refs, defaultValue) {
  return useCallbackRef(defaultValue, function (newValue) {
    return refs.forEach(function (ref) {
      return assignRef(ref, newValue);
    });
  });
}